import { JADWAL_GET } from './reduxConstant';
import { createReducer } from '../../../../App/common/utilities/reducerUtils';

const initialState = {
  jadwal: {},
  kelass: [],
  pelajarans: [],
  gurus: [],
};

const jadwalGet = (state, payload) => {
  let data = payload.jadwal;
  let jadwal = data.jadwal;
  let kelass = data.kelass;
  let pelajarans = data.pelajarans;
  let gurus = data.gurus;

  return {
    ...state,
    jadwal,
    kelass,
    pelajarans: pelajarans ?? state.pelajarans,
    gurus: gurus ?? state.gurus,
  };
};

export default createReducer(initialState, {
  [JADWAL_GET]: jadwalGet,
});
